/*
 * TEHOME universal SKU Media Gallery — instant variant switching.
 *
 * Eurus already fetches the selected variant's section HTML. We reuse that
 * response and replace only the media gallery, never the full page.
 */
(() => {
  const registeredSections = new Set();
  let swapping = false;

  function destroyGallery(root) {
    if (!root) return;

    root.querySelectorAll(".splide").forEach((element) => {
      if (element.splide && typeof element.splide.destroy === "function") {
        try { element.splide.destroy(true); } catch (error) {}
      }
    });

    if (window.Alpine && typeof Alpine.destroyTree === "function") {
      try { Alpine.destroyTree(root); } catch (error) {}
    }
  }

  function initializeGallery(root, sectionId) {
    if (!root) return;

    root.dataset.tehomeSkuMediaReady = "true";
    if (window.Alpine && typeof Alpine.initTree === "function") {
      Alpine.initTree(root);
    }

    document.dispatchEvent(new CustomEvent("tehome:sku-media-gallery:updated", {
      detail: {
        sectionId,
        variantId: root.dataset.tehomeRenderedVariant || "",
        hasSkuGallery: root.dataset.tehomeHasSkuGallery === "true"
      }
    }));
  }

  function swapFromEurusDocument(sectionId, html) {
    if (swapping || !html || typeof html.getElementById !== "function") return;

    const destination = document.getElementById("product-media-" + sectionId);
    const source = html.getElementById("product-media-" + sectionId);
    if (!destination || !source) return;

    const currentVariant = String(destination.dataset.tehomeRenderedVariant || "");
    const nextVariant = String(source.dataset.tehomeRenderedVariant || "");
    if (!nextVariant || nextVariant === currentVariant) return;

    const currentHasGallery = destination.dataset.tehomeHasSkuGallery === "true";
    const nextHasGallery = source.dataset.tehomeHasSkuGallery === "true";

    // Eurus retains its native behavior when neither side has a SKU gallery.
    if (!currentHasGallery && !nextHasGallery) return;

    swapping = true;
    destination.setAttribute("aria-busy", "true");
    destination.style.opacity = "0.55";
    destination.style.pointerEvents = "none";

    try {
      const replacement = source.cloneNode(true);
      destroyGallery(destination);
      destination.replaceWith(replacement);
      initializeGallery(replacement, sectionId);
    } finally {
      swapping = false;
    }
  }

  function register(root) {
    if (!root) return;
    const sectionId = root.id.replace("product-media-", "");
    if (!sectionId || registeredSections.has(sectionId)) return;

    registeredSections.add(sectionId);
    root.dataset.tehomeSkuMediaReady = "true";

    document.addEventListener(
      "eurus:product-page-variant-select:updated:" + sectionId,
      (event) => swapFromEurusDocument(sectionId, event.detail && event.detail.html)
    );
  }

  function init(scope = document) {
    scope.querySelectorAll('[id^="product-media-"][data-tehome-rendered-variant]').forEach(register);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target || document));
})();